import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../../../common/components/Checkbox';
import InputFieldErrorMessage from '../../../../common/components/InputFieldErrorMessage';
import styles from './EventListingsTermsField.module.scss';

const EventListingsTermsField = ({ termsField, onChange }) => {
  return (
    <div className={styles.termsField}>
      <Checkbox
        id="terms"
        className={styles.termsField__checkbox}
        name="terms"
        checked={termsField.value}
        onChange={onChange}
        size={20}
      />
      <div className={styles.termsField__helpText}>
        <span className={styles.termsField__helpText__label}>
          I accept the{' '}
          <a
            className={`${styles['policy-link']} analytics t-event-listings-policy`}
            href={window.eventListings.eventListingContentPolicyUrl}
            target="_blank"
            rel="noreferrer"
          >
            Event Promotion Policy
          </a>
          <span style={{ color: 'red' }}> *</span>
        </span>
        <p className={styles.termsField__helpText__description}>
          {termsField.description}
        </p>
        <InputFieldErrorMessage field={termsField} noMargin />
      </div>
    </div>
  );
};

EventListingsTermsField.propTypes = {
  onChange: PropTypes.func.isRequired,
  termsField: PropTypes.shape({
    value: PropTypes.bool,
    touched: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.string),
    description: PropTypes.string,
  }).isRequired,
};

export default EventListingsTermsField;
